<script>
  /* global Global */
  import Countdown from './Countdown.svelte';
  import LiveBox from './live/LiveBox.svelte';
  import LiveStandings from './live/LiveStandings.svelte';

  export let lang = undefined;

  const CHAMPIONSHIP_DATE = new Date(Global.date.countdown);
  const MILLISECONDS_IN_SECOND = 1000;
  const ONE_SECOND = MILLISECONDS_IN_SECOND;

  let today = new Date();

  (function refresh () {
    today = new Date();

    if (!CHAMPIONSHIP_DATE.getTime() > today.getTime()) return;

    setTimeout(refresh, ONE_SECOND);
  })();

  const liveStandings = Global.live.standings;
</script>

<div class='countdown-or-live'>
  <div class='countdown-or-live-prepend'/>

  {#if CHAMPIONSHIP_DATE.getTime() > today.getTime()}
    <Countdown bind:lang/>
  {:else if liveStandings.length > 0}
    <LiveStandings value={liveStandings} bind:lang/>
  {:else}
    <LiveBox/>
  {/if}

  <div class='countdown-or-live-append'/>
</div>

<style>
  .countdown-or-live {
    position: relative;

    display: flex;
    justify-content: center;

    width: 100%;
    height: 100px;

    background: var(--grey-1);
  }

  .countdown-or-live-prepend {
    position: absolute;
    left: 0px;

    width: 60px;
    height: 100%;

    background: linear-gradient(270deg, rgba(245, 245, 245, 0), rgba(245, 245, 245, 1) 87.5%);
  }

  .countdown-or-live-append {
    position: absolute;
    right: 0px;

    width: 60px;
    height: 100%;

    background: linear-gradient(90deg, rgba(245, 245, 245, 0), rgba(245, 245, 245, 1) 87.5%);
  }

  :global(body.dark) .countdown-or-live {
    background: var(--grey-8);
  }

  :global(body.dark) .countdown-or-live-prepend {
    background: linear-gradient(270deg, rgba(66, 66, 66, 0), rgba(66, 66, 66, 1) 87.5%);
  }

  :global(body.dark) .countdown-or-live-append {
    background: linear-gradient(90deg, rgba(66, 66, 66, 0), rgba(66, 66, 66, 1) 87.5%);
  }

  @media only screen and (max-width: 900px) {
    .countdown-or-live-prepend {
      width: 40px;
    }

    .countdown-or-live-append {
      width: 40px;
    }
  }

  @media only screen and (max-width: 415px) {
    .countdown-or-live-append {
      width: calc((100% - 335px) / 2);
    }

    .countdown-or-live-prepend {
      width: calc((100% - 335px) / 2);
    }
  }
</style>
